import { NgIf } from '@angular/common';
import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class ButtonComponent implements OnInit {
  @Input() name: string; //naam van de button
  @Input() type: ButtonTypeEnum; // soort van button, volgens de bootstrap classes
  @Input() buttonClass: string | undefined; // custom button class, deze overruled de boostrap class
  @Input() iconClass: string | undefined; // class voor het icon
  @Input() iconEndClass: string | undefined; // class voor het icon
  @Input() isSaving = false; // wanneer true, wordt de knop gedisabled en wordt het laadicoon getoond.
  @Input() typeAction = 'button'; // button: gewone button, submit = button om formulier door te sturen, reset = formulier leeg maken
  @Input() disabled = false; // wanneer true, wordt de knop gedisabled
  @Input() textSize = 'inherit';

  @Output() onClick = new EventEmitter<any>();
  // Alias voor onClick, zodat zowel (click) als (onClick) werken

  @ContentChild('content') content!: ElementRef;

  constructor() {
    this.type = ButtonTypeEnum.primary;
    this.name = 'Wijzigingen bewaren';
  }

  ngOnInit(): void {
    if (!this.buttonClass) {
      switch (this.type) {
        case ButtonTypeEnum.primary:
          this.buttonClass = 'btn-primary';
          break;
        case ButtonTypeEnum.secondary:
          this.buttonClass = 'btn-secondary';
          break;
        case ButtonTypeEnum.success:
          this.buttonClass = 'btn-success';
          break;
        case ButtonTypeEnum.danger:
          this.buttonClass = 'btn-danger';
          break;
        case ButtonTypeEnum.warning:
          this.buttonClass = 'btn-warning';
          break;
        case ButtonTypeEnum.info:
          this.buttonClass = 'btn-info';
          break;
        case ButtonTypeEnum.light:
          this.buttonClass = 'btn-light';
          break;
        case ButtonTypeEnum.dark:
          this.buttonClass = 'btn-dark';
          break;
        case ButtonTypeEnum.link:
          this.buttonClass = 'btn-link';
          break;
        default:
      }
    }
  }

  handleClick(event: Event): void {
    debugger
    if (this.isSaving || this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.onClick.emit(event);
  }
}

export enum ButtonTypeEnum {
  primary = 0,
  secondary,
  success,
  danger,
  warning,
  info,
  light,
  dark,
  link,
}
